import React, { Component } from 'react';
import presentacion2 from '../img/Presentacion2.png';
import '../css/Productos.css'
class Productos extends Component {
  render() {
    return (
      <div id="id-productos" className="contenedor-productos">
        <div className="fuente">
          <h1 className="titulo"> Flujo de Procesos </h1>
          <p className="subtitulo">Una solución de gestión administrativa completa, rápida, sencilla, modular y flexible.</p>
          <div className="flotante">
            <div className="subpanelFlotante">
              <a id="ventas-productos" type="button" className="btn btn-primary">
                <p id='ventas-parrafo'>Ventas</p></a>

              <a id='almacen-productos' type="button" className="btn btn-primary" >
                <p id='almacen-parrafo'>Almacenes</p></a>

              <a id='contabilidad-productos' type="button" className="btn btn-primary">
                <p id='contabilidad-parrafo'>Contabilidad</p></a>

              <a id="facturacion-productos" type="button" className="btn btn-primary">
                <p id="facturacion-parrafo">Facturación</p></a>

              <a id="reporte-productos" type="button" className="btn btn-primary">
                <p id="reporte-parrafo">Reportes</p></a>
            </div>
            <div className="panelProductos">
              <h3 className="panelProductos-titulo">SIIA ERP</h3>
              <p className="panelProductos-parrafo">Ventanas Interactivas y fáciles de usar  diseñados a la medida de tu empresa </p>
              <p className='parrafo-producto'>Control de cotización, pedidos, guiado y emisión de comprobantes</p>
              <img className='imagen-productos' src={presentacion2}></img>
              <a id="modulos" type="button" className="btn btn-primary" href="#contactos-final">
                <p className="modulosParrafo">Consultar el Producto</p></a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Productos;



// WEBPACK FOOTER //
// ./src/components/Productos.jsx